import { render, staticRenderFns } from "./DescargarInformeModal.vue?vue&type=template&id=222a5fac"
import script from "./DescargarInformeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DescargarInformeModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports